import {createAction, props} from '@ngrx/store';
import {ProleisObject} from '@proleis/proleis-rest-client';

export const LOAD_POSITION = createAction(
  '[Positions] load position',
  props<{ pboId: string, posId: string, aliasFields?: string }>()
);

export const ON_POSITION_LOADED_SUCCESS = createAction(
  '[Positions] position loaded',
  props<{ position: ProleisObject }>()
);

export const ON_POSITION_LOADED_ERROR = createAction(
  '[Positions] error while loading positions'
);

export const LOAD_TL_POSITIONS = createAction(
  '[Positions] load tl positions',
  props<{ orderId: string }>()
);

export const ON_TL_POSITIONS_LOADED_SUCCESS = createAction(
  '[Positions] tl positions loaded',
  props<{ positions: ProleisObject[] }>()
);

export const ON_TL_POSITIONS_LOADED_ERROR = createAction(
  '[Positions] error while loading tl positions'
);

export const LOAD_BM_POSITIONS = createAction(
  '[Positions] load bm positions',
  props<{ orderId: string }>()
);

export const ON_LOAD_BM_POSITIONS_SUCCESS = createAction(
  '[Positions] bm positions loaded',
  props<{ positions: ProleisObject[] }>()
);

export const ON_LOAD_BM_POSITIONS_ERROR = createAction(
  '[Positions] error while loading bm positions'
);

export const LOAD_TP_POSITIONS = createAction(
  '[Positions] load tp positions',
  props<{ orderId: string }>()
);

export const ON_LOAD_TP_POSITIONS_SUCCESS = createAction(
  '[Positions] tp positions loaded',
  props<{ positions: ProleisObject[] }>()
);

export const ON_LOAD_TP_POSITIONS_ERROR = createAction(
  '[Positions] error while loading tp positions'
);

export const LOAD_PM_DOCUMENTS = createAction(
  '[Positions] load pm documents',
  props<{ objectId: string, aliasFields?: string }>()
);

export const LOAD_PM_DOCUMENTS_SUCCESS = createAction(
  '[Positions] pm documents loaded',
  props<{ documents: ProleisObject[] }>()
);

export const LOAD_PM_DOCUMENTS_ERROR = createAction(
  '[Positions] error while loading pm documents'
);
